<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2" v-if="planProposal">
            <card-header
                :title="
                    $t('plan-proposal.form.texts.title', {
                        'title-prefix': $t('plan-proposal.breadcrumbs.show'),
                    })
                "
                :route="{
                    name: 'plan-proposal.index',
                    params: { customer_id: planProposal.customer.id },
                }"
            />

            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <customer-details :customer="planProposal.customer" />
                    </v-col>
                    <v-col cols="6">
                        <plan-package-details
                            :planPackage="planProposal.planPackage"
                            :planProposal="planProposal"
                        />
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <plan-proposal-details
                                :planProposal="planProposal"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PlanProposal from '@/models/PlanProposal'
import CardHeader from '@/components/utils/CardHeader'
import CustomerDetails from '@/components/common/CustomerDetails'
import PlanPackageDetails from '@/shared/components/plans/PlanPackageDetails'
import PlanProposalDetails from '@/shared/components/planProposal/PlanProposalDetails'

export default {
    props: {
        id: {
            required: true,
        },
    },

    data: () => {
        return {
            planProposal: null,
        }
    },

    components: {
        CardHeader,
        CustomerDetails,
        PlanPackageDetails,
        PlanProposalDetails,
    },

    methods: {
        async getPlanProposal() {
            let planProposal = await this.model
                .with('planPackage.modules.module')
                .with('customer')
                .find(this.id)

            this.planProposal = planProposal
        },
    },

    computed: {
        model() {
            return new PlanProposal()
        },
    },

    created() {
        this.getPlanProposal()
    },
}
</script>
